<template>
  <div class="form-field" :class="props.class">
    <label :for="uniqueId" class="form-label" v-html="props.label"></label>
    <div class="input-group">
      <slot name="prefix"></slot>
      <input class="form-control" v-bind="$attrs" :id="uniqueId" v-mask="props.mask" v-model="model">
      <slot name="suffix"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script setup>
import useUniqueId from '../../../directives/uniqueId';

defineOptions({
  inheritAttrs: false
});

const {uniqueId} = useUniqueId();

const props = defineProps({
  class: {
    type: String,
  },
  label: {
    type: String,
    default: 'Informe o label'
  },
  mask: {
    type: [String, Array],
    required: false,
  }
});

const model = defineModel({default:''});

</script>
